function showPassword(inputEl: HTMLInputElement, buttonEl: HTMLElement): void {
  inputEl.setAttribute('type', 'text');
  buttonEl.setAttribute('aria-label', 'Conceal Password');
  buttonEl.classList.remove('password-toggle--hidden');
  buttonEl.classList.add('password-toggle--visible');
}

function hidePassword(inputEl: HTMLInputElement, buttonEl: HTMLElement): void {
  inputEl.setAttribute('type', 'password');
  buttonEl.setAttribute('aria-label', 'Reveal Password');
  buttonEl.classList.remove('password-toggle--visible');
  buttonEl.classList.add('password-toggle--hidden');
}

export default function initPasswordToggles(): void {
  const toggles = document.querySelectorAll<HTMLElement>('[data-toggle="password"]');

  toggles.forEach((buttonEl) => {
    const targetEl = document.getElementById((buttonEl.dataset.target as string).substr(1)) as HTMLInputElement;

    if (!targetEl) return;

    targetEl.addEventListener('keyup', () => {
      if (targetEl.value === '') {
        buttonEl.classList.add('hide');
        hidePassword(targetEl, buttonEl);
      } else {
        buttonEl.classList.remove('hide');
      }
    });

    buttonEl.addEventListener('click', (e) => {
      e.preventDefault();
      targetEl.focus();

      if (targetEl.getAttribute('type') === 'password') {
        showPassword(targetEl, buttonEl);
      } else {
        hidePassword(targetEl, buttonEl);
      }
    });
  });
}
